import React from 'react';
import { Fire, Star, Leaf } from '@phosphor-icons/react';

/**
 * Premium product tag badges.
 * Tag: 'bestseller' | 'most-ordered' | 'healthy-choice'
 */
const TAG_CONFIG = {
  'bestseller': {
    label: 'Bestseller',
    icon: Fire,
    className: 'bg-gradient-to-br from-[#F97316] to-[#EA580C] text-white shadow-md shadow-orange-500/25',
  },
  'most-ordered': {
    label: 'Most Ordered',
    icon: Star,
    className: 'bg-gradient-to-br from-[#FBBF24] to-[#F59E0B] text-[#78350F] shadow-md shadow-amber-500/25',
  },
  'healthy-choice': {
    label: 'Healthy Choice',
    icon: Leaf,
    className: 'bg-gradient-to-br from-[#34D399] to-[#10B981] text-white shadow-md shadow-emerald-500/25',
  },
};

export const TagBadge = ({ tag, size = 'sm' }) => {
  const cfg = TAG_CONFIG[tag];
  if (!cfg) return null;
  const Icon = cfg.icon;
  const sizing = size === 'sm' ? 'text-[10px] px-2 py-1 gap-1' : 'text-xs px-2.5 py-1.5 gap-1.5';
  return (
    <span
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wide ${sizing} ${cfg.className}`}
      data-testid={`tag-${tag}`}
    >
      <Icon size={size === 'sm' ? 10 : 12} weight="fill" />
      {cfg.label}
    </span>
  );
};

export default TagBadge;
